export default "__VITE_ASSET__20d11933__"